import type { FeatureKey, MeResponse } from "@/features/auth/types";
import { hasFeature } from "@/lib/permissions/can";

/**
 * Presentation E (ADR 0068): a theme switched on by a registry module. Every
 * E style is scoped under `[data-ui="e"]` on <html>, so a clinic without the
 * module keeps exactly today's rendering.
 */
export const UI_TEMPLATE_E_FEATURE: FeatureKey = "ui_template_e";
export const UI_TEMPLATE_ATTRIBUTE = "data-ui";

/** True when the active clinic has the presentation E module. */
export function usesTemplateE(me: MeResponse | null): boolean {
  return hasFeature(me, UI_TEMPLATE_E_FEATURE);
}

/** Sets (or removes) `data-ui="e"` on the given root element. */
export function applyUiTemplate(
  enabled: boolean,
  root: HTMLElement = document.documentElement,
): void {
  if (enabled) root.setAttribute(UI_TEMPLATE_ATTRIBUTE, "e");
  else root.removeAttribute(UI_TEMPLATE_ATTRIBUTE);
}
